import { Alert, AlertIcon, AlertTitle } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";

export const FrameworkAgreementStoppedNotice = ({
  event,
}: {
  event: Pick<PortalSourcingEventDetailDto, "frameworkAgreementNoLongerActive">;
}) => {
  const { t } = useTranslation();
  if (!event.frameworkAgreementNoLongerActive) return null;
  return (
    <Alert status="warning" variant="subtle" rounded="md">
      <AlertIcon />
      <AlertTitle>
        {t(
          "The framework agreement this mini-competition is under is no longer active, so the competition can't be awarded, and no new tenders can be delivered.",
        )}
      </AlertTitle>
    </Alert>
  );
};
